export const IconEnum = {
    ArrowDown: 'arrow-down',
    SliderHorizontal: 'slider-horizontal',
    multiplyCircle: 'multiply-circle',
    downCircle: 'down-circle',
    circle: 'circle'
}

export type IconEnumType = 'arrow-down' | 'slider-horizontal' | 'multiply-circle' | 'down-circle' | 'circle'

export const GetIconUrl = (imageEnum: IconEnumType) => `${process.env.NEXT_PUBLIC_BASE_PATH}/images/${imageEnum}.svg`

export const ThemeColors = {
    white: '#FFFFFF',
    blue: '#2979FF',
    red: '#F44336',
    warning: '#D6733A',
    black: '#000000',
    gray40: '#9696A0',
    gray5: '#F0F0F1',
    gray10: '#F2F1F6',
    grayText: '#787885',
    backgroundAkmGreen: '#F0FDE2',
    blackGreenText: '#147918',
    greenYellowLight: '#EAFCD9',
    greenBackground: '#EAFCD9',
    grayBackground: '#f7f7f8',
    grayLightColor: '#F9F9FA',
    grayAkmBackgroundGray: '#E1E1E3',
    accentGreenLight: '#8CE36D',
    grayAkm5: '#F0F0F1',
    accentRed: '#EC1C24',
    accentGreen: '#5BD240',
    graySkeleton: '#e8e8e8',
    pureRed: '#F44336',
    orange: '#FCAF5C',
    pureRedLight: '#f2786f',
    getGrayColor: (opacity = 1) => `rgba(2, 13, 3, ${opacity})`,
    getGreenColor: (opacity = 1) => `rgba(91, 210, 64, ${opacity})`,
    getBlue60Color: (opacity = 1) => `rgba(41, 121, 255, ${opacity})`,
    getBlueColor: (opacity = 1) => `rgba(43, 66, 91, ${opacity})`,
    getRedheadColor: (opacity = 1) => `rgba(236, 28, 36, ${opacity})`,
    getPureRedColor: (opacity = 1) => `rgba(244, 67, 54, ${opacity})`,
    getRedColor: () => '#EC1C24',
    getRedAccent: (opacity = 1) => `rgba(154, 60, 69, ${opacity})`,
    getBlackColor: (opacity = 1) => `rgba(0, 0, 0, ${opacity})`
}

export enum ThemeColorsEnum {
    blue = 'blue',
    red = 'red',
    warning = 'warning'
}

export const RadiusConstants = {
    block: '12px',
    element: '5px'
}
